import { render, staticRenderFns } from "./HomeIndex.vue?vue&type=template&id=c71a746c&scoped=true&"
import script from "./HomeIndex.vue?vue&type=script&lang=js&"
export * from "./HomeIndex.vue?vue&type=script&lang=js&"
import style0 from "./HomeIndex.vue?vue&type=style&index=0&id=c71a746c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c71a746c",
  null
  
)

export default component.exports